import {exportBarSegments, exportTotalRecords} from './attendanceExportFigures'
import {AttendanceVisualSummary} from './buildAttendanceVisualSummary'

export function formatAttendanceExportSummaryLines(
  summary: AttendanceVisualSummary | null | undefined
): string[] {
  if (!summary) return []

  if (summary.mode === 'stats') {
    return summary.statPairs
      .map((p) => `${p.metric}: ${p.value}`)
      .filter((line) => line.trim() !== ':')
  }

  const lines: string[] = []
  const total = exportTotalRecords(summary)
  if (total > 0) {
    lines.push(`Total records: ${total}`)
  }
  const headlineLabel = summary.headlineLabel?.trim()
  if (headlineLabel && summary.totalRecords > 0) {
    const label = `${headlineLabel.charAt(0).toUpperCase()}${headlineLabel.slice(1)}`
    lines.push(`${label}: ${summary.totalRecords}`)
  }
  if (summary.presentPercent != null) {
    lines.push(`Attendance: ${summary.presentPercent}%`)
  }
  // Same bars, same order as the chart on screen.
  for (const seg of exportBarSegments(summary)) {
    lines.push(`${seg.label}: ${seg.count}`)
  }
  return lines
}
